var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgVideoTabUnfilled = function SvgVideoTabUnfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.105 18.317V11.67a1.86 1.86 0 00-1.808-1.9H5.614a1.86 1.86 0 00-1.807 1.9v18.989a1.86 1.86 0 001.807 1.9h21.684a1.86 1.86 0 001.807-1.9v-6.645l7.228 7.596V10.72l-7.228 7.597z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgVideoTabUnfilled;